/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileWorkflowAssignee } from './fileWorkflowAssignee';


export interface FileWorkflowDetailStep { 
    stepId: string;
    stepOrder: number;
    actionType: FileWorkflowDetailStep.ActionTypeEnum;
    actionTypeLabel: string;
    status: FileWorkflowDetailStep.StatusEnum;
    assignedUser?: FileWorkflowAssignee;
    completedOn?: string;
    rejectedOn?: string;
    comments?: string;
}
export namespace FileWorkflowDetailStep {
    export type ActionTypeEnum = 'review' | 'approve' | 'authorize' | 'acknowledge' | 'seen';
    export const ActionTypeEnum = {
        Review: 'review' as ActionTypeEnum,
        Approve: 'approve' as ActionTypeEnum,
        Authorize: 'authorize' as ActionTypeEnum,
        Acknowledge: 'acknowledge' as ActionTypeEnum,
        Seen: 'seen' as ActionTypeEnum
    };
    export type StatusEnum = 'pending' | 'in_progress' | 'completed' | 'rejected' | 'cancelled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        InProgress: 'in_progress' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Rejected: 'rejected' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


